import React from 'react';
import HeroSection from '../../component/schemess/HeroSection'
import Schemess from '../../component/schemess/Schemes';
import ProductBar from '../../component/schemess/ProductBar';

const Schemes = () => {
  return (
    <>
    <HeroSection />
    <Schemess />
    <ProductBar /></>
  )
}

export default Schemes